import React from 'react'
import BackgroundFormatItem from './BackgroundFormatItem';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import { CLI, FRONT, PROGRAM_CINEMAS, ROUTESDATA, TRANSLATION } from '../constants/state';
import getData from '../functions/getData';

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
    translation: getData(state, TRANSLATION), 
    routesData: getData(state, ROUTESDATA), 
    cinemas: getData(state, PROGRAM_CINEMAS)
})

const BackgroundFormatItemContainer = ({
    itemID, 
    itemData, 
    translation, 
    scrollToPosition, 
    cinemaDataFront,
    isMobile=false, 
    goToMoviepage=false,
    overviewFilterIgnoreOnPerformances,
    onClickItem, 
    hideInfo=false,
    routesData,
    index = '', 
    cinemas,
    filterValue,
    filterType,
    dayFilters,
    queryStringValues,
    stripeAppearance,
    showPerformances, 
    onOpenPerformancePage=null, 
}) => {
    if(!itemData) {
        return ''
    }

    const {
        poster_styling,
        hidden_attributes,
        attribute_styling,
        stripe_appearance
    } = cinemaDataFront

    const moviesRoutesData = routesData.movies.items

    return (
        <BackgroundFormatItem 
            itemData={itemData}
            attributeStyling={attribute_styling}
            translation={translation}
            itemID={itemID}
            scrollToPosition={scrollToPosition}
            dayFilters={dayFilters}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            isMobile={isMobile}
            hiddenAttributes={hidden_attributes}
            goToMoviepage={goToMoviepage}
            onClickItem={onClickItem}
            hideInfo={hideInfo}
            moviesRoutesData={moviesRoutesData}
            filterValue={filterValue}
            filterType={filterType}
            posterStyling={poster_styling}
            index={index}
            queryStringValues={queryStringValues}
            cinemas={cinemas}
            showPerformances={showPerformances}
            stripeAppearance={stripeAppearance ? stripeAppearance : stripe_appearance}
            onOpenPerformancePage={onOpenPerformancePage}
        />
    )
   
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(BackgroundFormatItemContainer)